import { Box, TextField, Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import axios from "../../assets/js/AxiosInterceptors";
import PopupForm from "../../Components/PopupForm";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import CustomeSelectField from "../../Components/CustomeSelectField";
import CustomTextField from "../../Components/CustomTextField";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import host from "../../assets/js/Host";

const cookies = new Cookies();
const RenderContent = (props) => {
  const [t] = useTranslation("common");
  const maintheme = useSelector((state) => state.themeData.maintheme);
  return (
    <Box className="Container-fluid">
      <Box className="row pt-4">
        <Box className="col-12 col-sm-12 col-md-10 m-auto">
          <CustomeSelectField
            label={"users"}
            haswidth={true}
            value={props?.selected ? props?.selected : []}
            list={props?.users ? props?.users : []}
            customGetOptionLabel={(option) => option?.label}
            error={false}
            message={[]}
            multiple={true}
            readOnly={false}
            focused={true}
            onChange={(e, newValue) => {
              props?.setSelected(newValue);
            }}
            onClearClick={() => {
              props?.setSelected([]);
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

const RenderFooter = (props) => {
  const gridtheme = useSelector((state) => state.themeData.gridtheme);
  const [t] = useTranslation("common");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box display="flex">
          <Button
            variant="outlined"
            // spacing={2}
            sx={{
              width: "50% !important",
              // flexGrow: 1,
              minWidth: "80px !important",
              maxWidth: "80px !important",
              margin: 1,
              backgroundColor: "#f7f7f7",
              borderColor: gridtheme?.colorWhite,
              color: gridtheme?.colorblack,
              boxShadow: "0 0 7px -2px white",
              //   color:SearchButtonTheme?.clear_button_text_color,
              "&:hover": {
                backgroundColor: "#f7f7f7",
                borderColor: gridtheme?.colorWhite,
                color: gridtheme?.colorblack,
                boxShadow: "0 0 7px 1px white",
                boxShadow: "0",
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterClear"
            color="secondary"
            onClick={() => {
              props.setOpen(false);
            }}
          >
            {"Close"}
          </Button>
          <Button
            variant="contained"
            // spacing={2}
            sx={{
              // flexGrow: 1,
              margin: 1,
              width: "80px !important",
              minWidth: "80px !important",
              maxWidth: "80px !important",
              "&:hover": {
                //   backgroundColor:SearchButtonTheme?.search_button_color+'88',
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterSearch"
            onClick={() => {
              props.submit();
            }}
          >
            {"Save"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default function AssignUser2(props) {
  const [t] = useTranslation("common");
  const [name, setName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [id, setId] = useState([]);
  const [spin, setSpin] = useState(false);
  const [assigned, setAssigned] = useState(props.assigned);
  const [selected, setSelected] = useState([]);
  const [selectedNames, setSelectedNames] = useState("");
  const [users, setUsers] = useState([]);

  useEffect(() => {
    console.log("users data", props?.users);
    if (props?.users?.length > 0) {
      let arr = [];
      props?.users?.length > 0 &&
        props?.users?.map((itm) => {
          arr.push({
            ...itm,
            id: itm?.value,
          });
        });
      setUsers(arr);
    }
  }, [props?.users]);
  useEffect(() => {
    if (users && users?.length > 0) {
      let arr = [];
      props.assigned &&
        props.assigned?.length > 0 &&
        props.assigned?.map((itm) => {
          users?.map((itm2) => {
            if (itm2?.value == itm) {
              arr.push(itm2);
            }
          });
        });
      setSelected(arr);
    }
    console.log("dssdfsdfsdsdsdsd", props.assigned);
  }, [props.assigned, users]);

  // const submit = async () => {
  //     try {
  //         setLoading(true)

  //         let data = {
  //             name: callTypeObject?.name?.value,
  //             web_or_mobile: callTypeObject?.web_or_mobile?.value,
  //         }
  //         let result = null;
  //         if (props?.object?.id) {
  //             data = {
  //                 ...data,
  //                 id: props?.object?.id,
  //                 _method: 'put'
  //             }
  //             result = await CallsTypeAPI.updatecallsType({
  //                 data: data
  //             });
  //         } else {
  //             result = await CallsTypeAPI.addCallsType({
  //                 data: data
  //             });
  //         }

  //         if (result?.status) {
  //             setLoading(false)
  //             toast.success()
  //             clearForm()
  //             props.loadData()
  //             props.setAddForm(false)
  //         } else {

  //             if (typeof result.errorMessage === "object") {
  //                 let updatedObject = resetErrors(callTypeObject)
  //                 setCallTypeObject(checkErrors(result.errorMessage, updatedObject))
  //             }
  //             setLoading(false)
  //             toast.error(t('NETWORKMESSAGE.messageError'))
  //         }
  //         setLoading(false)
  //     } catch (error) {
  //         setLoading(false)
  //         toast.error(error?.message)
  //     }

  // }
  const assign_user = () => {
    // if ( id.length > 0) {
    let arr = [];
    if (props?.assigned ) {
      props?.assigned?.length &&
        props?.assigned?.map((itm) => {
          let check = false;
          let id = 0;
          if(itm)
          selected&&selected?.length>0&&selected?.map((itm2) => {
            if (itm2?.id == itm) {
              check = true;
              id = itm2?.id;
            }
          });
          if (check && id) {
            arr.push(id);
          } else if (!itm) {
            arr.push(itm);
          }
        });
    }
    let arr2=[...arr,...selected?.map(itm=>itm?.id)]
    const uniqueArr = arr2.filter((elem, index, self) => {
        return index === self.indexOf(elem)||arr2[index]==null;
      });

    setLoading(true);
    var headers = {
      jwt: cookies.get("token"),
    };
    axios({
      url: host + `tasks/assign/${props.id}`,
      method: "POST",
      headers: headers,
      data: {
        users_id: uniqueArr,
      },
    })
      .then((res) => {
        if (res.data.status === true) {
          toast.success("user assigned successfully");
          const { onRefTask } = props.onRefTask;
          onRefTask();
          setLoading(false);
          props.setAddForm(false);
        } else if (res.data.status === false) {
          setLoading(false);
          toast.error(res.data.data.message.text);
        }
      })
      .catch((err) => {
        toast.error("Network Error");
      });

    // }
    // else{
    //     return toast.error("Select User First")
    // }
  };

  const clearForm = () => {
    setName(null);
    setData([]);
    setId([]);
    setSpin(false);
    setAssigned(props.assigned);
    setSelected([]);
    setSelectedNames("");
    setUsers([]);
  };

  useEffect(() => {
    if (!props?.users) clearForm();
  }, [props?.addForm, props?.users]);

  return (
    <PopupForm
      open={props.addForm}
      setOpen={props.setAddForm}
      title={"Assigned users"}
      content={
        <RenderContent
          selected={selected}
          setSelected={setSelected}
          users={users}
          open={props.addForm}
          setOpen={props.setAddForm}
        />
      }
      footer={
        <RenderFooter
          open={props.addForm}
          setOpen={props.setAddForm}
          submit={assign_user}
        />
      }
    />
  );
}
